import { render, staticRenderFns } from "./UpdateFormModal.vue?vue&type=template&id=a070ea7e&lang=pug"
import script from "./UpdateFormModal.vue?vue&type=script&lang=js"
export * from "./UpdateFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports